import React, { CSSProperties } from 'react';
import '../css/roundButton.css';

interface RoundButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  text?: string;
  icon?: React.ReactNode | string;
  iconPosition?: 'left' | 'right';
  showIcon?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  styleInjectButton?: CSSProperties;
}

const RoundButton: React.FC<RoundButtonProps> = ({
  children,
  onClick,
  className,
  text = 'Button',
  icon = '',
  iconPosition = 'right',
  showIcon = true,
  disabled = false,
  type = 'button',
  styleInjectButton
}) => {

  const styleVaribleHero =  {
    '--round-button-hero-text-color': styleInjectButton?.color,
    '--round-button-hero-text-weight': styleInjectButton?.fontWeight,
    '--round-button-hero-text-font-style': styleInjectButton?.fontStyle,
    '--round-button-hero-text-font-size': styleInjectButton?.fontSize,
  }  as CSSProperties


  const renderIcon = () => {
    if (!showIcon) return null;

    return (
      <span className="scl--web-component-round-button-icon">
        {icon}
      </span>
    );
  };

  const renderContent = () => {
    if (children) return children;

    return (
      <>
        {iconPosition === 'left' && renderIcon()}
        <span className="scl--web-component-round-button-text" style={styleVaribleHero}>{text}</span>
        {iconPosition === 'right' && renderIcon()}
      </>
    );
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`scl--web-component-round-button ${disabled ? 'disabled' : ''} ${className || ''}`}
      disabled={disabled}
    >
      {renderContent()}
    </button>
  );
};

export default RoundButton;
